"use client";

import { useInfront } from "@/context/infront-context";
import { useEffect, useRef } from "react";

type SimpleChartProps = {
  instrument: {
    feed: number;
    ticker: string;
  };
  periods: string[];
  defaultPeriod?: string;
  title?: string;
};

const ID = "simple-chart";

const SimpleChart = (props: SimpleChartProps) => {
  const { isReady, load } = useInfront();

  const widgetRef = useRef<any>(null);

  useEffect(() => {
    let active = true;

    load?.(["core", "highstock", "hollowcandlestick", "heikinashi"]).then(() => {
      if (!isReady || !active) return;

      widgetRef.current?.destroy();
      widgetRef.current = null;

      const widgetOptions = new window.Infront.ChartWidgetOptions();

      widgetOptions.instruments = [props.instrument];

      widgetOptions.topToolbar = {
        periodMenu: true,
        fullScreenButton: true,
      };

      widgetOptions.selectablePeriods = props.periods;
      widgetOptions.defaultPeriod = props.defaultPeriod || "1D";
      widgetOptions.chartType = "baseline";
      widgetOptions.showPrevClose = false;
      widgetOptions.gridType = "none";
      widgetOptions.showSeriesLabels = false;
      widgetOptions.showLegend = false;

      widgetOptions.topToolbarLabels = {
        periodMenu: {
          isIcon: false,
          value: new window.Infront.Observable("Period"),
        },
      };

      widgetOptions.cursorEventsEnabled = false;

      widgetRef.current = window.infront.chartWidget(`#${ID}`, widgetOptions);
    });

    return () => {
      active = false;
      widgetRef.current?.destroy();
      widgetRef.current = null;
    };
  }, [isReady, props.instrument, props.periods]);

  return (
    <div className="card h-[400px]">
      {props.title && (
        <p className="text-lg font-semibold px-3 pt-3">{props.title}</p>
      )}
      <div id={ID} className="h-full" />
    </div>
  );
};

export default SimpleChart;
